module.exports = __webpack_public_path__ + "static/img/SustainabilityReport_2024_cover_TW.29a3b51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SustainabilityReport_2024_cover_TW.jpg
// module id = fFOw
// module chunks = 1